import Request, { RequestUpdateBody } from "app/models/request"

export enum Types {
  PATCH = "REQUESTS_PATCH",
  PATCH_SUCCESS = "REQUESTS_PATCH_SUCCESS",
  PATCH_FAIL = "REQUESTS_PATCH_FAIL",
  POST = "REQUESTS_POST",
  POST_SUCCESS = "REQUESTS_POST_SUCCESS",
  POST_FAIL = "REQUESTS_POST_FAIL",
}

export type Action =
  | PatchRequestsAction
  | PatchRequestsSuccessAction
  | PatchRequestsFailAction
  | PostRequestsAction
  | PostRequestsSuccessAction
  | PostRequestsFailAction

export type PatchRequestsAction = {
  payload: { requestUpdates: RequestUpdateBody[] }
  type: Types.PATCH
}

export type PatchRequestsSuccessAction = {
  type: Types.PATCH_SUCCESS
}

export type PatchRequestsFailAction = {
  payload: { errors: object }
  type: Types.PATCH_FAIL
}

export type PostRequestsAction = {
  payload: { data: Request[] }
  type: Types.POST
}

export type PostRequestsSuccessAction = {
  type: Types.POST_SUCCESS
}

export type PostRequestsFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export function patchRequests(requestUpdates: RequestUpdateBody[]): PatchRequestsAction {
  return {
    payload: { requestUpdates },
    type: Types.PATCH,
  }
}

export function patchRequestsSuccess(): PatchRequestsSuccessAction {
  return {
    type: Types.PATCH_SUCCESS,
  }
}

export function patchRequestsFail(errors: object): PatchRequestsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}

export function postRequests(payload: { data: Request[] }): PostRequestsAction {
  return {
    payload,
    type: Types.POST,
  }
}

export function postRequestsSuccess(): PostRequestsSuccessAction {
  return {
    type: Types.POST_SUCCESS,
  }
}

export function postRequestsFail(errors: object): PostRequestsFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}
